var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconScan = function SvgIconScan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5 3.75a1 1 0 0 1 1-1h3.75a1 1 0 0 1 1 1V7.5a1 1 0 1 1-2 0V4.75H16.5a1 1 0 0 1-1-1M3.75 15.5a1 1 0 0 1 1 1v2.75H7.5a1 1 0 1 1 0 2H3.75a1 1 0 0 1-1-1V16.5a1 1 0 0 1 1-1M21.25 16.5a1 1 0 1 0-2 0v2.75H16.5a1 1 0 1 0 0 2h3.75a1 1 0 0 0 1-1zM2.75 3.75a1 1 0 0 1 1-1H7.5a1 1 0 0 1 0 2H4.75V7.5a1 1 0 0 1-2 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.625 6.875a1.75 1.75 0 0 0-1.75 1.75v6.75c0 .966.784 1.75 1.75 1.75h6.75a1.75 1.75 0 0 0 1.75-1.75v-6.75a1.75 1.75 0 0 0-1.75-1.75zm.25 8.25v-6.25h6.25v6.25z",
    clipRule: "evenodd"
  }))));
};
export default SvgIconScan;